import config from './internal/config';
import path, {getAppPath} from './internal/appPath';
import debug from 'debug';
const log = debug('linksoft:app');

function getDefinedUrls() {
    return config().url || {};
}

function url(urlName, args) {
    try {
        const factory = getDefinedUrls()[urlName];
        if (typeof factory === 'function') {
            return factory(args);
        }
    } catch(e) {
        log(`Invalid named URL '${urlName}'. Error: %o`, e);
    }
    return '#invalid-url'; // fake URL instead of JS exception
}

const module = {
    path,
    url
};

function createProp(key, getter) {
    Object.defineProperty(module, key, {
        enumerable: true,
        configurable: true,
        get: getter
    });
}

createProp('root', getAppPath);

export default module;


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/app.js